import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FaqSection = () => {
    const { t } = useLanguage();
    return (
        <section id="faq" className="scroll-mt-24 py-12 md:py-20" aria-labelledby="faq-title" data-testid="faq-section">
            <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <Overline>{t.faq.overline}</Overline>
                    <h2 id="faq-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        {t.faq.title}
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
                        {t.faq.items.map((item, i) => (
                            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-ink/10" data-testid={`faq-item-${i + 1}`}>
                                <AccordionTrigger
                                    className="py-5 text-start text-base font-semibold text-ink transition-colors duration-300 hover:text-pine hover:no-underline md:text-lg"
                                    data-testid={`faq-trigger-${i + 1}`}
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm leading-relaxed text-mist md:text-base" data-testid={`faq-content-${i + 1}`}>
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
};

export default FaqSection;
